/**
 * The product directory: the original 37-product brief plus approved additions.
 * Names and categories come from the user's product list and follow-up requests.
 *
 * Catalog evidence: the existing repository files
 *   public/catalogs/klean-leaf-catalog.pdf
 *   src/Assets/klean_leaf_catalog.pdf
 * are byte-identical (SHA-256:
 * f2566ee3c993d5bb68e175bef444093dc7216d3b32241b796379d4cf43dcdab2).
 * Pages 2–5 were extracted and visually checked. catalogPage is 1-based.
 * catalogName preserves the source wording where the display name differs.
 * No catalog SKU is inferred from a similar formulation, variant, or family.
 * A catalog entry is not evidence of current availability or certification.
 * category is the primary category; additionalCategories also participate in
 * directory filters, counts, and category labels without duplicating the product
 * or its URL.
 *
 * sku is a newly assigned Klean Leaf website identifier, separate from the
 * verified catalogSku. Keep each explicit code stable when records are reordered
 * or category labels change. A SKU does not imply production, availability,
 * certification, or confirmed specifications.
 *
 * Format: KL-[purpose/form]-[variant]. S = sheets, T = tablets, P = pods,
 * PW = powder; LD = laundry detergent, DD = dishwasher detergent,
 * MPC = multi-purpose cleaning, TBC = toilet bowl cleaner, GC = glass cleaning,
 * HS = hand soap. DMCT/CMCT = dishwasher/coffee machine cleaning tablets;
 * BBCT = baby bottle cleaning tablets; LMT = laundry machine tablets.
 * HCT = home care tablets, used for the combined laundry/dishwashing/cleaning kit.
 * Other families: CCS/CAS = color catcher/absorbing sheets; DRS = dryer sheets;
 * DSS = dissolvable fabric softener sheets; DYS = dyeing sheets; FCS = floor cleaning
 * sheets; LBP = laundry booster pods; FBB = fragrance booster beads;
 * SRS/SRW/SRP = stain removal spray/wipes/pen; WDB = wool dryer balls;
 * SBT/FBT = spray/foaming bottle.
 * Variants describe the requested product names: RG = regular/unqualified entry,
 * EZ3 = 3-in-1 enzyme, SE5 = 5-in-1 solid enzyme, BY = baby, PF = PVA-free,
 * BF = bamboo fiber, BK = black, SU = single use, CT = concentrated,
 * PT = pet owners, VM = vending machine pack, GL = glass.
 * PL means powder + liquid for detergent pods, plastic for bottles.
 * KT = kit, using the corresponding base product form (e.g. GCS-RG/GCS-KT).
 *
 * Edit a product's images array to replace a placeholder or add photography:
 *   images: [{ src: primaryImage, alt: "Product packaging" },
 *            { src: "/images/product-detail.webp", alt: "Product detail" }]
 * Array order controls the gallery; images[0] is also used by cards and SEO.
 * Keep one SKU-specific primary first. Secondary photos must match that SKU's
 * packaging and product form, including its pack count. Add { src, alt } entries here;
 * gallery components do not need changes. An explicit one-image array is valid.
 * Records without an images array preserve the existing primary placeholder
 * and receive the shared secondary placeholder until photography is available.
 * Gallery audit, generation prompts and documented missing-reference exceptions
 * are recorded in productGalleryGeneration.json. Run the coverage script after edits.
 */

import productInUseImage0 from "../Assets/products/product-in-use/klean-leaf-laundry-detergent-sheets-product-in-use.webp";
import productInUseImage1 from "../Assets/products/product-in-use/klean-leaf-3-in-1-enzyme-laundry-detergent-sheets-product-in-use.webp";
import productInUseImage2 from "../Assets/products/product-in-use/klean-leaf-5-in-1-solid-enzyme-laundry-detergent-sheets-product-in-use.webp";
import productInUseImage3 from "../Assets/products/product-in-use/klean-leaf-baby-laundry-detergent-sheets-for-sensitive-skin-product-in-use.webp";
import productInUseImage4 from "../Assets/products/product-in-use/klean-leaf-pva-free-laundry-detergent-sheets-product-in-use.webp";
import productInUseImage5 from "../Assets/products/product-in-use/klean-leaf-color-catcher-sheets-product-in-use.webp";
import productInUseImage6 from "../Assets/products/product-in-use/klean-leaf-color-absorbing-sheets-product-in-use.webp";
import productInUseImage7 from "../Assets/products/product-in-use/klean-leaf-dryer-sheets-product-in-use.webp";
import productInUseImage8 from "../Assets/products/product-in-use/klean-leaf-premium-bamboo-fiber-dryer-sheets-product-in-use.webp";
import productInUseImage9 from "../Assets/products/product-in-use/klean-leaf-dissolvable-soften-sheets-product-in-use.webp";
import productInUseImage10 from "../Assets/products/product-in-use/klean-leaf-laundry-black-dyeing-magic-sheets-product-in-use.webp";
import productInUseImage11 from "../Assets/products/product-in-use/klean-leaf-dishwasher-detergent-sheets-product-in-use.webp";
import productInUseImage12 from "../Assets/products/product-in-use/klean-leaf-toilet-bowl-cleaner-sheets-product-in-use.webp";
import productInUseImage13 from "../Assets/products/product-in-use/klean-leaf-floor-cleaning-sheets-product-in-use.webp";
import productInUseImage14 from "../Assets/products/product-in-use/klean-leaf-glass-cleaning-sheet-product-in-use.webp";
import productInUseImage15 from "../Assets/products/product-in-use/klean-leaf-hand-soap-sheet-single-use-product-in-use.webp";
import productInUseImage16 from "../Assets/products/product-in-use/klean-leaf-hand-soap-sheet-concentrated-product-in-use.webp";
import productInUseImage17 from "../Assets/products/product-in-use/klean-leaf-laundry-detergent-powder-product-in-use.webp";
import productInUseImage18 from "../Assets/products/product-in-use/klean-leaf-multi-purpose-cleaning-powder-product-in-use.webp";
import productInUseImage19 from "../Assets/products/product-in-use/klean-leaf-dishwasher-detergent-powder-product-in-use.webp";
import productInUseImage20 from "../Assets/products/product-in-use/klean-leaf-toilet-bowl-cleaner-powder-product-in-use.webp";
import productInUseImage21 from "../Assets/products/product-in-use/klean-leaf-dishwasher-tablets-product-in-use.webp";
import productInUseImage22 from "../Assets/products/product-in-use/klean-leaf-dishwasher-machine-cleaning-tablets-product-in-use.webp";
import productInUseImage23 from "../Assets/products/product-in-use/klean-leaf-multi-purpose-cleaning-tablets-product-in-use.webp";
import productInUseImage24 from "../Assets/products/product-in-use/klean-leaf-laundry-detergent-tablets-product-in-use.webp";
import productInUseImage25 from "../Assets/products/product-in-use/klean-leaf-hand-soap-tablets-product-in-use.webp";
import productInUseImage26 from "../Assets/products/product-in-use/klean-leaf-baby-nursing-bottle-cleaning-tablets-product-in-use.webp";
import productInUseImage27 from "../Assets/products/product-in-use/klean-leaf-laundry-machine-tablets-for-pet-owners-product-in-use.webp";
import productInUseImage28 from "../Assets/products/product-in-use/klean-leaf-toilet-bowl-cleaner-tablets-product-in-use.webp";
import productInUseImage29 from "../Assets/products/product-in-use/klean-leaf-coffee-machine-cleaning-tablets-product-in-use.webp";
import productInUseImage30 from "../Assets/products/product-in-use/klean-leaf-glass-cleaning-tablets-product-in-use.webp";
import productInUseImage31 from "../Assets/products/product-in-use/klean-leaf-laundry-pods-product-in-use.webp";
import productInUseImage32 from "../Assets/products/product-in-use/klean-leaf-dishwasher-pods-product-in-use.webp";
import productInUseImage33 from "../Assets/products/product-in-use/klean-leaf-dishwasher-pods-powder-liquid-product-in-use.webp";
import productInUseImage34 from "../Assets/products/product-in-use/klean-leaf-booster-laundry-pods-product-in-use.webp";
import productInUseImage35 from "../Assets/products/product-in-use/klean-leaf-fragrance-booster-beads-product-in-use.webp";
import productInUseImage36 from "../Assets/products/product-in-use/klean-leaf-fragrance-booster-beads-concentrated-product-in-use.webp";
import productInUseImage37 from "../Assets/products/product-in-use/klean-leaf-stain-removal-spray-product-in-use.webp";
import productInUseImage38 from "../Assets/products/product-in-use/klean-leaf-stain-removal-wipes-product-in-use.webp";
import productInUseImage39 from "../Assets/products/product-in-use/klean-leaf-stain-removal-pen-product-in-use.webp";
import productInUseImage40 from "../Assets/products/product-in-use/klean-leaf-wool-dryer-balls-product-in-use.webp";
import productInUseImage41 from "../Assets/products/product-in-use/klean-leaf-laundry-detergent-sheets-vending-machine-pack-product-in-use.webp";
import productInUseImage42 from "../Assets/products/product-in-use/klean-leaf-plastic-spray-bottle-product-in-use.webp";
import productInUseImage43 from "../Assets/products/product-in-use/klean-leaf-glass-foaming-bottle-product-in-use.webp";
import productInUseImage44 from "../Assets/products/product-in-use/klean-leaf-glass-spray-bottle-product-in-use.webp";
import productInUseImage45 from "../Assets/products/product-in-use/klean-leaf-multi-purpose-sheet-kit-product-in-use.webp";
import productInUseImage46 from "../Assets/products/product-in-use/klean-leaf-multi-purpose-tablet-kit-product-in-use.webp";
import productInUseImage47 from "../Assets/products/product-in-use/klean-leaf-glass-cleaning-sheet-kit-product-in-use.webp";
import productInUseImage48 from "../Assets/products/product-in-use/klean-leaf-glass-cleaning-tablet-kit-product-in-use.webp";
import productInUseImage49 from "../Assets/products/product-in-use/klean-leaf-hand-soap-sheet-kit-product-in-use.webp";
import productInUseImage50 from "../Assets/products/product-in-use/klean-leaf-hand-soap-tablet-kit-product-in-use.webp";
import productInUseImage51 from "../Assets/products/product-in-use/klean-leaf-laundry-dishwashing-multi-purpose-cleaning-tablet-kit-product-in-use.webp";

import laundryDetergentSheetsImage from "../Assets/products/klean-leaf-laundry-detergent-sheets.webp";
import enzymeLaundryDetergentSheetsImage from "../Assets/products/klean-leaf-3-in-1-enzyme-laundry-detergent-sheets.webp";
import solidEnzymeLaundryDetergentSheetsImage from "../Assets/products/klean-leaf-5-in-1-solid-enzyme-laundry-detergent-sheets.webp";
import babyLaundryDetergentSheetsImage from "../Assets/products/klean-leaf-baby-laundry-detergent-sheets.webp";
import pvaFreeLaundryDetergentSheetsImage from "../Assets/products/klean-leaf-pva-free-laundry-detergent-sheets.webp";
import colorCatcherSheetsImage from "../Assets/products/klean-leaf-color-catcher-sheets.webp";
import colorAbsorbingSheetsImage from "../Assets/products/klean-leaf-color-absorbing-sheets.webp";
import dryerSheetsImage from "../Assets/products/klean-leaf-dryer-sheets.webp";
import bambooFiberDryerSheetsImage from "../Assets/products/klean-leaf-premium-bamboo-fiber-dryer-sheets.webp";
import dissolvableSoftenSheetsImage from "../Assets/products/klean-leaf-dissolvable-soften-sheets.webp";
import blackDyeingSheetsImage from "../Assets/products/klean-leaf-laundry-black-dyeing-magic-sheets.webp";
import toiletBowlCleanerSheetsImage from "../Assets/products/klean-leaf-toilet-bowl-cleaner-sheets.webp";
import floorCleaningSheetsImage from "../Assets/products/klean-leaf-floor-cleaning-sheets.webp";
import glassCleaningSheetImage from "../Assets/products/klean-leaf-glass-cleaning-sheet.webp";
import handSoapSheetSingleUseImage from "../Assets/products/klean-leaf-hand-soap-sheet-single-use.webp";
import handSoapSheetConcentratedImage from "../Assets/products/klean-leaf-hand-soap-sheet-concentrated.webp";
import laundryDetergentSheetsPackagingImage from "../Assets/products/klean-leaf-laundry-detergent-sheets-packaging-and-sheets.webp";
import laundryDetergentSheetsWashingImage from "../Assets/products/klean-leaf-laundry-detergent-sheets-washing-machine.webp";
import enzymeLaundryDetergentSheetsCountertopImage from "../Assets/products/klean-leaf-3-in-1-enzyme-laundry-detergent-sheets-countertop.webp";
import enzymeLaundryDetergentSheetsWashingImage from "../Assets/products/klean-leaf-3-in-1-enzyme-laundry-detergent-sheets-washing-machine.webp";
import solidEnzymeLaundryDetergentSheetsWashingImage from "../Assets/products/klean-leaf-5-in-1-solid-enzyme-laundry-detergent-sheets-washing-machine.webp";
import solidEnzymeLaundryDetergentSheetsGranulesImage from "../Assets/products/klean-leaf-5-in-1-solid-enzyme-laundry-detergent-sheets-granules-detail.webp";
import solidEnzymeLaundryDetergentSheetsEnzymesImage from "../Assets/products/klean-leaf-5-in-1-solid-enzyme-laundry-detergent-sheets-enzyme-types.webp";
import babyLaundryDetergentSheetsPouchImage from "../Assets/products/klean-leaf-baby-laundry-detergent-sheets-pouch-and-sheets.webp";
import babyLaundryDetergentSheetsLaundryImage from "../Assets/products/klean-leaf-baby-laundry-detergent-sheets-laundry-room.webp";
import colorCatcherSheetsDetailImage from "../Assets/products/klean-leaf-color-catcher-sheets-box-and-sheets.webp";
import colorAbsorbingSheetsWashingImage from "../Assets/products/klean-leaf-color-absorbing-sheets-washing-machine.webp";
import dryerSheetsDetailImage from "../Assets/products/klean-leaf-dryer-sheets-open-dryer.webp";
import dissolvableSoftenSheetsPackagingImage from "../Assets/products/klean-leaf-dissolvable-soften-sheets-packaging-and-sheets.webp";
import dissolvableSoftenSheetsLaundryImage from "../Assets/products/klean-leaf-dissolvable-soften-sheets-laundry-room.webp";
import toiletBowlCleanerSheetsUseImage from "../Assets/products/klean-leaf-toilet-bowl-cleaner-sheets-bathroom-use.webp";
import glassCleaningSheetUseImage from "../Assets/products/klean-leaf-glass-cleaning-sheet-water-demonstration.webp";
import handSoapSheetConcentratedRefillImage from "../Assets/products/klean-leaf-hand-soap-sheet-concentrated-bottle-refill.webp";
import floorCleaningSheetsMoppingImage from "../Assets/products/klean-leaf-floor-cleaning-sheets-mopping.webp";
import handSoapSheetSingleUseWashingImage from "../Assets/products/klean-leaf-hand-soap-sheet-single-use-handwashing.webp";
import pvaFreeLaundryDetergentSheetsTextureImage from "../Assets/products/klean-leaf-pva-free-laundry-detergent-sheets-texture-detail.webp";
import laundryDetergentPowderImage from "../Assets/products/klean-leaf-laundry-detergent-powder.webp";
import laundryDetergentPowderScoopImage from "../Assets/products/klean-leaf-laundry-detergent-powder-scoop-and-towels.webp";
import laundryDetergentPowderWashingImage from "../Assets/products/klean-leaf-laundry-detergent-powder-washing-machine.webp";
import multiPurposeCleaningPowderImage from "../Assets/products/klean-leaf-multi-purpose-cleaning-powder.webp";
import multiPurposeCleaningPowderSprayImage from "../Assets/products/klean-leaf-multi-purpose-cleaning-powder-spray-bottle.webp";
import dishwasherTabletsImage from "../Assets/products/klean-leaf-dishwasher-tablets.webp";
import dishwasherMachineCleaningTabletsImage from "../Assets/products/klean-leaf-dishwasher-machine-cleaning-tablets.webp";
import dishwasherDetergentPowderImage from "../Assets/products/klean-leaf-dishwasher-detergent-powder.webp";
import toiletBowlCleanerPowderImage from "../Assets/products/klean-leaf-toilet-bowl-cleaner-powder.webp";
import dishwasherDetergentSheetsImage from "../Assets/products/klean-leaf-dishwasher-detergent-sheets.webp";
import multiPurposeCleaningTabletsImage from "../Assets/products/klean-leaf-multi-purpose-cleaning-tablets.webp";
import handSoapTabletsImage from "../Assets/products/klean-leaf-hand-soap-tablets.webp";
import homeCareTabletKitImage from "../Assets/products/klean-leaf-laundry-dishwashing-multi-purpose-tablet-kit.webp";
import woolDryerBallsImage from "../Assets/products/klean-leaf-wool-dryer-balls.webp";
import woolDryerBallsThreePackImage from "../Assets/products/klean-leaf-wool-dryer-balls-three-pack.webp";
import woolDryerBallsHighlightsImage from "../Assets/products/klean-leaf-wool-dryer-balls-product-highlights.webp";
import vendingMachinePackImage from "../Assets/products/klean-leaf-laundry-detergent-sheets-vending-machine-pack.webp";
import vendingMachineDisplayImage from "../Assets/products/klean-leaf-laundry-detergent-sheets-vending-machine-display.webp";
import plasticSprayBottlesImage from "../Assets/products/klean-leaf-plastic-spray-bottles.webp";
import glassFoamingBottlesImage from "../Assets/products/klean-leaf-glass-foaming-bottles.webp";
import glassSprayBottlesImage from "../Assets/products/klean-leaf-glass-spray-bottles.webp";
import multiPurposeTabletKitImage from "../Assets/products/klean-leaf-multi-purpose-cleaning-tablet-kit.webp";
import multiPurposeTabletKitRefillImage from "../Assets/products/klean-leaf-multi-purpose-cleaning-tablet-kit-bottle-refill.webp";
import multiPurposeTabletKitKitchenImage from "../Assets/products/klean-leaf-multi-purpose-cleaning-tablet-kit-kitchen-refill.webp";
import handSoapTabletKitImage from "../Assets/products/klean-leaf-hand-soap-tablet-kit.webp";
import handSoapTabletKitRefillImage from "../Assets/products/klean-leaf-hand-soap-tablet-kit-bottle-refill.webp";
import laundryDetergentTabletsImage from "../Assets/products/klean-leaf-laundry-detergent-tablets.webp";
import babyBottleCleaningTabletsImage from "../Assets/products/klean-leaf-baby-bottle-cleaning-tablets.webp";
import petOwnerLaundryMachineTabletsImage from "../Assets/products/klean-leaf-laundry-machine-tablets-for-pet-owners.webp";
import toiletBowlCleanerTabletsImage from "../Assets/products/klean-leaf-toilet-bowl-cleaner-tablets.webp";
import coffeeMachineCleaningTabletsImage from "../Assets/products/klean-leaf-coffee-machine-cleaning-tablets.webp";
import glassCleaningTabletsImage from "../Assets/products/klean-leaf-glass-cleaning-tablets.webp";
import glassCleaningSheetKitImage from "../Assets/products/klean-leaf-glass-cleaning-sheet-kit.webp";
import glassCleaningTabletKitImage from "../Assets/products/klean-leaf-glass-cleaning-tablet-kit.webp";
import glassCleaningSheetKitDetailImage from "../Assets/products/gallery/klean-leaf-glass-cleaning-sheet-kit-detail.webp";
import glassCleaningTabletKitDetailImage from "../Assets/products/gallery/klean-leaf-glass-cleaning-tablet-kit-detail.webp";
import laundryDetergentPodsImage from "../Assets/products/klean-leaf-laundry-detergent-pods.webp";
import dishwasherDetergentPodsImage from "../Assets/products/klean-leaf-dishwasher-detergent-pods.webp";
import dishwasherPowderLiquidPodsImage from "../Assets/products/klean-leaf-dishwasher-detergent-pods-powder-liquid.webp";
import laundryBoosterPodsImage from "../Assets/products/klean-leaf-laundry-booster-pods.webp";
import fragranceBeadsOceanBreezeImage from "../Assets/products/klean-leaf-fragrance-booster-beads-ocean-breeze.webp";
import concentratedFragranceBeadsLavenderImage from "../Assets/products/klean-leaf-fragrance-booster-beads-concentrated-lavender.webp";
import stainRemovalWipesImage from "../Assets/products/klean-leaf-stain-removal-wipes.webp";
import stainRemovalSprayImage from "../Assets/products/klean-leaf-stain-removal-spray.webp";
import stainRemovalPenImage from "../Assets/products/klean-leaf-stain-removal-pen.webp";
import stainRemovalPenGreenImage from "../Assets/products/klean-leaf-stain-removal-pen-green-detail.webp";
import stainRemovalPenUseImage from "../Assets/products/klean-leaf-stain-removal-pen-travel-use.webp";
import stainRemovalPenPortableImage from "../Assets/products/klean-leaf-stain-removal-pen-portable-comparison.webp";
import stainRemovalSprayUseImage from "../Assets/products/klean-leaf-stain-removal-spray-use-guide.webp";
import stainRemovalEnzymeGuideImage from "../Assets/blogs/klean-leaf-enzyme-stain-guide.webp";
import multiPurposeSheetKitImage from "../Assets/products/klean-leaf-multi-purpose-cleaning-sheet-kit.webp";
import multiPurposeSheetsRefillImage from "../Assets/products/klean-leaf-multi-purpose-cleaning-sheets-bottle-refill.webp";
import handSoapSheetKitImage from "../Assets/products/klean-leaf-hand-soap-sheet-kit.webp";
import galleryKLDRSBFImage from "../Assets/products/gallery/klean-leaf-premium-bamboo-fiber-dryer-sheets-lifestyle.webp";
import galleryKLDYSBKImage from "../Assets/products/gallery/klean-leaf-laundry-black-dyeing-magic-sheets-lifestyle.webp";
import galleryKLDDSRGImage from "../Assets/products/gallery/klean-leaf-dishwasher-detergent-sheets-lifestyle.webp";
import galleryKLDDPWRGImage from "../Assets/products/gallery/klean-leaf-dishwasher-detergent-powder-lifestyle.webp";
import galleryKLTBCPWRGImage from "../Assets/products/gallery/klean-leaf-toilet-bowl-cleaner-powder-lifestyle.webp";
import galleryKLDDTRGImage from "../Assets/products/gallery/klean-leaf-dishwasher-tablets-lifestyle.webp";
import galleryKLDMCTRGImage from "../Assets/products/gallery/klean-leaf-dishwasher-cleaning-tablets-lifestyle.webp";
import galleryKLMPCTRGImage from "../Assets/products/gallery/klean-leaf-multi-purpose-tablets-use.webp";
import galleryKLLDTRGImage from "../Assets/products/gallery/klean-leaf-laundry-detergent-tablets-lifestyle.webp";
import galleryKLHSTRGImage from "../Assets/products/gallery/klean-leaf-hand-soap-tablets-lifestyle.webp";
import galleryKLBBCTRGImage from "../Assets/products/gallery/klean-leaf-baby-nursing-bottle-cleaning-tablets-lifestyle.webp";
import galleryKLLMTPTImage from "../Assets/products/gallery/klean-leaf-laundry-machine-tablets-for-pet-owners-lifestyle.webp";
import galleryKLTBCTRGImage from "../Assets/products/gallery/klean-leaf-toilet-bowl-cleaner-tablets-lifestyle.webp";
import galleryKLCMCTRGImage from "../Assets/products/gallery/klean-leaf-coffee-machine-cleaning-tablets-lifestyle.webp";
import galleryKLGCTRGImage from "../Assets/products/gallery/klean-leaf-glass-cleaning-tablets-lifestyle.webp";
import galleryKLLDPRGImage from "../Assets/products/gallery/klean-leaf-laundry-pods-lifestyle.webp";
import galleryKLDDPRGImage from "../Assets/products/gallery/klean-leaf-dishwasher-pods-lifestyle.webp";
import galleryKLDDPPLImage from "../Assets/products/gallery/klean-leaf-dishwasher-pods-powder-liquid-lifestyle.webp";
import galleryKLLBPRGImage from "../Assets/products/gallery/klean-leaf-booster-laundry-pods-lifestyle.webp";
import galleryKLFBBRGImage from "../Assets/products/gallery/klean-leaf-fragrance-booster-beads-lifestyle.webp";
import galleryKLFBBCTImage from "../Assets/products/gallery/klean-leaf-fragrance-booster-beads-concentrated-lifestyle.webp";
import galleryKLSRWRGImage from "../Assets/products/gallery/klean-leaf-stain-removal-wipes-use.webp";
import galleryKLSBTPLImage from "../Assets/products/gallery/klean-leaf-plastic-spray-bottle-lifestyle.webp";
import galleryKLFBTGLImage from "../Assets/products/gallery/klean-leaf-glass-foaming-bottle-lifestyle.webp";
import galleryKLSBTGLImage from "../Assets/products/gallery/klean-leaf-glass-spray-bottle-lifestyle.webp";
import galleryKLHCTKTImage from "../Assets/products/gallery/klean-leaf-laundry-dishwashing-multi-purpose-cleaning-tablet-kit-lifestyle.webp";

import productImageAlt from "../Assets/products/alt-text.json";

export const catalogSource = {
  url: "/catalogs/klean-leaf-catalog.pdf",
  name: "Klean Leaf Product Catalog",
  provenance: "Existing repository catalog; pages 2–5 reviewed.",
};

export const productPlaceholder = {
  src: "/images/product-placeholder.svg",
  alt: "Product image coming soon",
};

export const secondaryProductPlaceholder = {
  src: "/images/product-gallery-placeholder.svg",
  alt: "Additional product image coming soon",
};

const productDefinitions = [
  {
    name: "Laundry Detergent Sheets",
    slug: "laundry-detergent-sheets",
    sku: "KL-LDS-RG",
    category: "sheets",
    images: [
      {
        src: laundryDetergentSheetsImage,
        alt: productImageAlt["klean-leaf-laundry-detergent-sheets.webp"],
      },
      {
        src: laundryDetergentSheetsPackagingImage,
        alt: productImageAlt["klean-leaf-laundry-detergent-sheets-packaging-and-sheets.webp"],
      },
      {
        src: productInUseImage0,
        alt: productImageAlt["klean-leaf-laundry-detergent-sheets-product-in-use.webp"],
      },
      {
        src: laundryDetergentSheetsWashingImage,
        alt: productImageAlt["klean-leaf-laundry-detergent-sheets-washing-machine.webp"],
      },
    ],
    description: "Klean Leaf manufactures private label laundry detergent sheets for your brand. Discuss custom formulas, fragrances, sheet sizes and packaging, with specifications confirmed for your project.",
    // Optional ordered PDP modules. Maintenance guide: docs/product-detail-sections.md.
    // Evidence: Production.js, how-to-use-laundry-detergent-sheets.jsx,
    // About.js, and custom-fragrance-laundry-detergent-sheets.jsx.
    detailSections: [
      {
        id: "packaging", type: "packaging", enabled: true,
        description: "Explore the retail box format shown here and discuss packaging for your brand.",
        options: [{
          id: "paper-box", packagingType: "paperBox", name: "Paper Box",
          description: "Custom-printed retail packaging for laundry detergent sheets.",
          note: "Pack count, dimensions and artwork are confirmed for your project.",
          image: { src: laundryDetergentSheetsImage, alt: "Klean Leaf laundry detergent sheets retail box" },
        }],
      },
      {
        // Highlights are authored per product; other SKUs receive no shared fallback copy.
        // Conventional formula, popularity and quick dissolution confirmed by the user, 2026-10-09.
        id: "highlights", type: "productHighlights", enabled: true,
        title: "Product Highlights",
        image: {
          src: laundryDetergentSheetsPackagingImage,
          alt: "A thin Klean Leaf laundry detergent sheet resting against a compact stack of sheets beside the retail box",
          fit: "contain",
        },
        items: [
          {
            id: "classic-formula",
            text: "Our most popular laundry sheet, made with a classic formula using conventional laundry detergent ingredients.",
          },
          {
            id: "quick-dissolving",
            text: "Dissolves quickly in wash water, releasing detergent as the sheet breaks down.",
          },
          {
            id: "paper-packaging",
            text: "Paper box and envelope packaging options reduce reliance on bulky plastic detergent bottles.",
          },
          {
            id: "no-mess",
            text: "No mess: no sticky measuring caps, liquid drips or loose powder to spill.",
          },
          {
            id: "travel-friendly",
            text: "Travel friendly: pack a few dry sheets for hotel stays, RV trips or visits to the laundromat, without a liquid bottle to leak.",
          },
          {
            id: "space-saving",
            text: "Space saving: flat sheets stack neatly in a drawer or small laundry cupboard.",
          },
        ],
        ingredients: [
          "DI Water",
          "Glycerin",
          "Sodium Coco Sulfate (optional)",
          "Saponins",
          "Fragrance (optional)",
          "Sodium Carbonate",
          "Sodium Citrate",
          "Laureth-7",
          "Decyl Glucoside",
          "Polyvinyl Alcohol",
          "Sodium Fatty Acid Methyl Ester Sulfonate",
          "Potassium Cocoate",
        ],
      },
      {
        id: "usage", type: "howToUse", enabled: true,
        steps: [
          { id: "load", title: "Load your laundry", description: "Place your laundry in the washing machine." },
          { id: "add", title: "Add the detergent sheet", description: "Place the sheet on top of the clothes inside the drum." },
          { id: "wash", title: "Start the wash", description: "Select the wash cycle that suits your laundry and start the machine." },
        ],
        note: "Use the sheet quantity on the finished product label and follow garment care instructions.",
      },
      {
        id: "customization", type: "customization", enabled: true,
        description: "Build a product brief around your scent, sheet format and retail presentation.",
        categories: [
          {
            id: "fragrance", title: "Fragrance",
            description: "Discuss a stock fragrance, a custom scent direction or a fragrance-free formula for your laundry sheet project.",
            items: ["Existing Klean Leaf fragrance options", "Custom fragrance development", "Fragrance-free formula review"],
            note: "Custom fragrances have a separate minimum order quantity.",
          },
          {
            id: "specifications", title: "Product Specifications",
            description: "Review the sheet format and pack count against your product brief.",
            items: ["Sheet dimensions", "Perforated sheet formats", "Sheets per retail package"],
            image: { src: laundryDetergentSheetsPackagingImage, alt: "Laundry detergent sheets beside their Klean Leaf retail box" },
          },
          {
            id: "artwork", title: "Packaging & Artwork",
            description: "Discuss paper bag, paper box or bulk refill packaging, with artwork and carton planning for your brand.",
            items: ["Packaging format and dimensions", "Artwork integration and packaging samples", "Outer carton planning"],
            image: { src: laundryDetergentSheetsImage, alt: "Printed Klean Leaf laundry detergent sheets box" },
          },
        ],
        note: "Custom formulations are subject to technical review, testing, and MOQ requirements.",
        cta: { label: "Discuss Your Customization" },
      },
      {
        id: "moq", type: "moq", enabled: true,
        description: "MOQ starts at 1,000 retail package units per SKU.",
        quantity: "1,000", unit: "retail package units", scope: "Starting quantity per SKU",
        rows: [{
          id: "custom-fragrance", configuration: "Custom fragrance", quantity: "150,000", unit: "individual sheets",
          note: "Per custom fragrance. The number of retail boxes or pouches depends on the pack count.",
        }],
        note: "Confirm the MOQ for your selected packaging and formulation in your project quotation.",
        cta: { label: "Confirm Your MOQ" },
      },
      {
        id: "retail-format", type: "imageText", enabled: true, imageSide: "left",
        eyebrow: "Packaging details", title: "From sheet format to retail presentation",
        description: "Review the sheet format alongside your packaging brief. Sheet dimensions, pack count and artwork can be discussed together.",
        image: { src: laundryDetergentSheetsPackagingImage, alt: "Klean Leaf laundry detergent sheets beside a retail box" },
      },
      {
        id: "laundry-routine", type: "imageText", enabled: true, imageSide: "right",
        eyebrow: "In use", title: "A sheet format for everyday laundry",
        description: "Laundry detergent sheets go into the washing machine drum with your clothes. Confirm the final directions for the formulation and sheet size you select.",
        image: { src: laundryDetergentSheetsWashingImage, alt: "Klean Leaf laundry detergent sheet being placed in a washing machine" },
      },
    ],
    // Page 2 has several laundry-sheet variants, not one generic catalog SKU.
  },
  {
    name: "3-in-1 Enzyme Laundry Detergent Sheets",
    slug: "3-in-1-enzyme-laundry-detergent-sheets",
    sku: "KL-LDS-EZ3",
    category: "sheets",
    images: [
      {
        src: enzymeLaundryDetergentSheetsImage,
        alt: productImageAlt["klean-leaf-3-in-1-enzyme-laundry-detergent-sheets.webp"],
      },
      {
        src: enzymeLaundryDetergentSheetsCountertopImage,
        alt: productImageAlt["klean-leaf-3-in-1-enzyme-laundry-detergent-sheets-countertop.webp"],
      },
      {
        src: productInUseImage1,
        alt: productImageAlt["klean-leaf-3-in-1-enzyme-laundry-detergent-sheets-product-in-use.webp"],
      },
      {
        src: enzymeLaundryDetergentSheetsWashingImage,
        alt: productImageAlt["klean-leaf-3-in-1-enzyme-laundry-detergent-sheets-washing-machine.webp"],
      },
    ],
    description: "Develop 3-in-1 enzyme laundry detergent sheets with Klean Leaf’s private label manufacturing team. Discuss custom formulation, sheet specifications and packaging, then confirm availability for your project.",
    // The user supplied the enzyme benefits, specialist development context and ingredient list.
    detailSections: [
      {
        id: "highlights", type: "productHighlights", enabled: true,
        title: "Product Highlights",
        image: {
          src: enzymeLaundryDetergentSheetsCountertopImage,
          alt: "Klean Leaf 3-in-1 enzyme laundry detergent sheets and a stack of sheets beside their retail box",
          fit: "contain",
        },
        items: [
          {
            id: "standard-sheet-benefits",
            text: "Includes all the benefits of our standard Laundry Detergent Sheets.",
            link: {
              href: "/products/laundry-detergent-sheets#product-laundry-detergent-sheets-detail-highlights",
              label: "View standard sheet highlights.",
            },
          },
          {
            id: "enzyme-blend",
            text: "A 3-in-1 enzyme blend adds cleaning power to the classic sheet formula, helping break down stains during the wash.",
          },
          {
            id: "sweat-and-sportswear",
            text: "Helps remove sweat stains from activewear, workout clothes and sports uniforms.",
          },
          {
            id: "specialist-development",
            text: "Building on this 3-in-1 formula, we have also developed multifunctional cleaning sheets for laboratories and clinics, with formulations tailored to their cleaning needs.",
          },
        ],
        ingredients: [
          "DI Water",
          "Glycerin",
          "Sodium Coco Sulfate",
          "Saponins",
          "Fragrance (optional)",
          "Sodium Carbonate",
          "Sodium Citrate",
          "Laureth-7",
          "Decyl Glucoside",
          "Polyvinyl Alcohol",
          "Sodium Fatty Acid Methyl Ester Sulfonate",
          "Potassium Cocoate",
        ],
      },
    ],
  },
  {
    name: "5-in-1 Solid Enzyme Laundry Detergent Sheets",
    slug: "5-in-1-solid-enzyme-laundry-detergent-sheets",
    sku: "KL-LDS-SE5",
    category: "sheets",
    images: [
      {
        src: solidEnzymeLaundryDetergentSheetsImage,
        alt: productImageAlt["klean-leaf-5-in-1-solid-enzyme-laundry-detergent-sheets.webp"],
      },
      {
        src: solidEnzymeLaundryDetergentSheetsWashingImage,
        alt: productImageAlt["klean-leaf-5-in-1-solid-enzyme-laundry-detergent-sheets-washing-machine.webp"],
      },
      {
        src: productInUseImage2,
        alt: productImageAlt["klean-leaf-5-in-1-solid-enzyme-laundry-detergent-sheets-product-in-use.webp"],
      },
      {
        src: solidEnzymeLaundryDetergentSheetsGranulesImage,
        alt: productImageAlt["klean-leaf-5-in-1-solid-enzyme-laundry-detergent-sheets-granules-detail.webp"],
      },
      {
        src: solidEnzymeLaundryDetergentSheetsEnzymesImage,
        alt: productImageAlt["klean-leaf-5-in-1-solid-enzyme-laundry-detergent-sheets-enzyme-types.webp"],
      },
    ],
    description: "Plan private label 5-in-1 solid enzyme laundry detergent sheets with Klean Leaf. Review custom formula requirements, sheet specifications and branded packaging; availability is confirmed for your project.",
    // The user supplied the performance, materials, production details and ingredient list.
    detailSections: [
      {
        id: "highlights", type: "productHighlights", enabled: true,
        title: "Product Highlights",
        image: {
          src: solidEnzymeLaundryDetergentSheetsGranulesImage,
          alt: "Klean Leaf solid enzyme laundry detergent sheets with a close-up of enzyme granules on the sheet surface",
          fit: "contain",
        },
        items: [
          {
            id: "strongest-cleaning",
            text: "Our most powerful laundry sheet, offering the strongest cleaning and stain removal in our current laundry sheet range.",
          },
          {
            id: "premium-brands",
            text: "Favored by some premium and luxury brands.",
          },
          {
            id: "environmentally-friendly-materials",
            text: "Made entirely with environmentally friendly materials.",
          },
          {
            id: "textured-enzyme-surface",
            text: "A textured surface with enzyme granules you can feel, unlike the smoother surface of our standard laundry sheets.",
          },
          {
            id: "enzyme-application",
            text: "Enzyme granules are sprayed onto the sheets during the drying process.",
          },
          {
            id: "premium-performance",
            text: "Priced above our standard laundry sheets, with the best cleaning performance in our range.",
          },
        ],
        ingredients: [
          "DI Water",
          "Glycerin",
          "Sodium Coco Sulfate",
          "Saponins",
          "Fragrance (optional)",
          "Sodium Carbonate",
          "Sodium Citrate",
          "Laureth-7",
          "Decyl Glucoside",
          "Polyvinyl Alcohol",
          "Sodium Fatty Acid Methyl Ester Sulfonate",
          "Potassium Cocoate",
          "Amylase",
        ],
      },
    ],
  },
  {
    name: "Baby Laundry Detergent Sheets (for Sensitive Skin)",
    slug: "baby-laundry-detergent-sheets-for-sensitive-skin",
    sku: "KL-LDS-BY",
    category: "sheets",
    images: [
      {
        src: babyLaundryDetergentSheetsImage,
        alt: productImageAlt["klean-leaf-baby-laundry-detergent-sheets.webp"],
      },
      {
        src: babyLaundryDetergentSheetsPouchImage,
        alt: productImageAlt["klean-leaf-baby-laundry-detergent-sheets-pouch-and-sheets.webp"],
      },
      {
        src: productInUseImage3,
        alt: productImageAlt["klean-leaf-baby-laundry-detergent-sheets-for-sensitive-skin-product-in-use.webp"],
      },
      {
        src: babyLaundryDetergentSheetsLaundryImage,
        alt: productImageAlt["klean-leaf-baby-laundry-detergent-sheets-laundry-room.webp"],
      },
    ],
    description: "Develop baby laundry detergent sheets under your own brand with Klean Leaf. Discuss formula, fragrance and custom packaging requirements; sensitive-skin suitability and supporting product information must be confirmed.",
  },
  {
    name: "PVA-Free Laundry Detergent Sheets",
    slug: "pva-free-laundry-detergent-sheets",
    sku: "KL-LDS-PF",
    category: "sheets",
    images: [
      {
        src: pvaFreeLaundryDetergentSheetsImage,
        alt: productImageAlt["klean-leaf-pva-free-laundry-detergent-sheets.webp"],
      },
      {
        src: pvaFreeLaundryDetergentSheetsTextureImage,
        alt: productImageAlt["klean-leaf-pva-free-laundry-detergent-sheets-texture-detail.webp"],
      },
      {
        src: productInUseImage4,
        alt: productImageAlt["klean-leaf-pva-free-laundry-detergent-sheets-product-in-use.webp"],
      },
    ],
    description: "Discuss PVA-free laundry detergent sheet development with Klean Leaf’s manufacturing team. Review custom formulation, sheet specifications and private label packaging, with development and supply status confirmed before ordering.",
  },
  {
    name: "Color Catcher Sheets",
    slug: "color-catcher-sheets",
    sku: "KL-CCS-RG",
    category: "sheets",
    images: [
      {
        src: colorCatcherSheetsImage,
        alt: productImageAlt["klean-leaf-color-catcher-sheets.webp"],
      },
      {
        src: colorCatcherSheetsDetailImage,
        alt: productImageAlt["klean-leaf-color-catcher-sheets-box-and-sheets.webp"],
      },
      {
        src: productInUseImage5,
        alt: productImageAlt["klean-leaf-color-catcher-sheets-product-in-use.webp"],
      },
    ],
    description: "Contact us to discuss specifications and availability for Color Catcher Sheets for your laundry care range.",
    // Kept separate from catalog-listed Color Absorbing Sheets (KL_FS_7).
  },
  {
    name: "Color-Absorbing Sheets",
    slug: "color-absorbing-sheets",
    sku: "KL-CAS-RG",
    category: "sheets",
    images: [
      {
        src: colorAbsorbingSheetsImage,
        alt: productImageAlt["klean-leaf-color-absorbing-sheets.webp"],
      },
      {
        src: colorAbsorbingSheetsWashingImage,
        alt: productImageAlt["klean-leaf-color-absorbing-sheets-washing-machine.webp"],
      },
      {
        src: productInUseImage6,
        alt: productImageAlt["klean-leaf-color-absorbing-sheets-product-in-use.webp"],
      },
    ],
    description: "Laundry sheets for absorbing loose dyes. Contact us to discuss product specifications and intended use.",
    catalogSku: "KL_FS_7",
    catalogPage: 2,
  },
  {
    name: "Dryer Sheets",
    slug: "dryer-sheets",
    sku: "KL-DRS-RG",
    category: "sheets",
    images: [
      {
        src: dryerSheetsImage,
        alt: productImageAlt["klean-leaf-dryer-sheets.webp"],
      },
      {
        src: dryerSheetsDetailImage,
        alt: productImageAlt["klean-leaf-dryer-sheets-open-dryer.webp"],
      },
      {
        src: productInUseImage7,
        alt: productImageAlt["klean-leaf-dryer-sheets-product-in-use.webp"],
      },
    ],
    description: "Sheets for use in dryer cycles. Contact us to discuss specifications for your laundry care range.",
    catalogSku: "KL_FS_12",
    catalogPage: 2,
  },
  {
    name: "Premium Bamboo Fiber Dryer Sheets",
    slug: "premium-bamboo-fiber-dryer-sheets",
    sku: "KL-DRS-BF",
    category: "sheets",
    images: [
      {
        src: bambooFiberDryerSheetsImage,
        alt: productImageAlt["klean-leaf-premium-bamboo-fiber-dryer-sheets.webp"],
      },
      {
        src: galleryKLDRSBFImage,
        alt: productImageAlt["klean-leaf-premium-bamboo-fiber-dryer-sheets-lifestyle.webp"],
      },
      {
        src: productInUseImage8,
        alt: productImageAlt["klean-leaf-premium-bamboo-fiber-dryer-sheets-product-in-use.webp"],
      },
    ],
    description: "Discuss material requirements, product specifications, and availability for this dryer sheet project.",
  },
  {
    name: "Dissolvable Fabric Softener Sheets",
    slug: "dissolvable-soften-sheets",
    sku: "KL-DSS-RG",
    category: "sheets",
    images: [
      {
        src: dissolvableSoftenSheetsImage,
        alt: productImageAlt["klean-leaf-dissolvable-soften-sheets.webp"],
      },
      {
        src: dissolvableSoftenSheetsPackagingImage,
        alt: productImageAlt["klean-leaf-dissolvable-soften-sheets-packaging-and-sheets.webp"],
      },
      {
        src: productInUseImage9,
        alt: productImageAlt["klean-leaf-dissolvable-soften-sheets-product-in-use.webp"],
      },
      {
        src: dissolvableSoftenSheetsLaundryImage,
        alt: productImageAlt["klean-leaf-dissolvable-soften-sheets-laundry-room.webp"],
      },
    ],
    description: "Dissolvable sheets for fabric softening. Contact us to discuss the formulation and specifications for your project.",
    catalogSku: "KL_FS_9",
    catalogPage: 2,
  },
  {
    name: "Laundry Black Dyeing Magic Sheets",
    slug: "laundry-black-dyeing-magic-sheets",
    sku: "KL-DYS-BK",
    category: "sheets",
    images: [
      {
        src: blackDyeingSheetsImage,
        alt: productImageAlt["klean-leaf-laundry-black-dyeing-magic-sheets.webp"],
      },
      {
        src: galleryKLDYSBKImage,
        alt: productImageAlt["klean-leaf-laundry-black-dyeing-magic-sheets-lifestyle.webp"],
      },
      {
        src: productInUseImage10,
        alt: productImageAlt["klean-leaf-laundry-black-dyeing-magic-sheets-product-in-use.webp"],
      },
    ],
    description: "Contact us to discuss specifications, intended use, and availability for Laundry Black Dyeing Magic Sheets.",
  },
  {
    name: "Dishwasher Detergent Sheets",
    slug: "dishwasher-detergent-sheets",
    sku: "KL-DDS-RG",
    category: "sheets",
    images: [
      {
        src: dishwasherDetergentSheetsImage,
        alt: productImageAlt["klean-leaf-dishwasher-detergent-sheets.webp"],
      },
      {
        src: galleryKLDDSRGImage,
        alt: productImageAlt["klean-leaf-dishwasher-detergent-sheets-lifestyle.webp"],
      },
      {
        src: productInUseImage11,
        alt: productImageAlt["klean-leaf-dishwasher-detergent-sheets-product-in-use.webp"],
      },
    ],
    description: "Detergent sheets for automatic dishwashers. Contact us to discuss formulation, directions for use, and product specifications.",
  },
  {
    name: "Toilet Bowl Cleaner Sheets",
    slug: "toilet-bowl-cleaner-sheets",
    sku: "KL-TBCS-RG",
    category: "sheets",
    images: [
      {
        src: toiletBowlCleanerSheetsImage,
        alt: productImageAlt["klean-leaf-toilet-bowl-cleaner-sheets.webp"],
      },
      {
        src: toiletBowlCleanerSheetsUseImage,
        alt: productImageAlt["klean-leaf-toilet-bowl-cleaner-sheets-bathroom-use.webp"],
      },
      {
        src: productInUseImage12,
        alt: productImageAlt["klean-leaf-toilet-bowl-cleaner-sheets-product-in-use.webp"],
      },
    ],
    description: "Dissolvable sheets for toilet bowl cleaning. Contact us to discuss product specifications and use requirements.",
    // Packaging/photo evidence: this product's existing images; catalog page 2.
    // Approved dosage, brushing directions and timing are still needed.
    detailSections: [
      {
        id: "packaging", type: "packaging", enabled: true,
        options: [{
          id: "paper-box", packagingType: "paperBox", name: "Paper Box",
          description: "Retail box presentation for toilet bowl cleaner sheets.",
          note: "Discuss the pack count, box specification and artwork for your project.",
          image: { src: toiletBowlCleanerSheetsImage, alt: "Klean Leaf toilet bowl cleaner sheets retail box" },
        }],
      },
      { id: "usage", type: "howToUse", enabled: false, steps: [] },
      {
        id: "moq", type: "moq", enabled: true,
        message: "Contact us to confirm the MOQ for your configuration.",
        note: "Include your preferred retail pack count and packaging requirements in your inquiry.",
        cta: { label: "Confirm Your MOQ" },
      },
      {
        id: "bathroom-format", type: "imageText", enabled: true, imageSide: "right",
        eyebrow: "Product format", title: "Toilet care in a sheet format",
        description: "Explore dissolvable sheets for toilet bowl cleaning. Discuss the sheet specification, retail packaging and final directions for your product.",
        image: { src: toiletBowlCleanerSheetsUseImage, alt: "Klean Leaf toilet bowl cleaner sheets shown in a bathroom" },
      },
    ],
    catalogSku: "KL_FS_11",
    catalogPage: 2,
  },
  {
    name: "Floor Cleaning Sheets",
    slug: "floor-cleaning-sheets",
    sku: "KL-FCS-RG",
    category: "sheets",
    images: [
      {
        src: floorCleaningSheetsImage,
        alt: productImageAlt["klean-leaf-floor-cleaning-sheets.webp"],
      },
      {
        src: floorCleaningSheetsMoppingImage,
        alt: productImageAlt["klean-leaf-floor-cleaning-sheets-mopping.webp"],
      },
      {
        src: productInUseImage13,
        alt: productImageAlt["klean-leaf-floor-cleaning-sheets-product-in-use.webp"],
      },
    ],
    description: "Dissolvable sheets for floor cleaning. Contact us to discuss specifications and suitability for your intended surfaces.",
    catalogSku: "KL_FS_6",
    catalogPage: 2,
  },
  {
    name: "Glass Cleaning Sheets",
    slug: "glass-cleaning-sheet",
    sku: "KL-GCS-RG",
    category: "sheets",
    images: [
      {
        src: glassCleaningSheetImage,
        alt: productImageAlt["klean-leaf-glass-cleaning-sheet.webp"],
      },
      {
        src: glassCleaningSheetUseImage,
        alt: productImageAlt["klean-leaf-glass-cleaning-sheet-water-demonstration.webp"],
      },
      {
        src: productInUseImage14,
        alt: productImageAlt["klean-leaf-glass-cleaning-sheet-product-in-use.webp"],
      },
    ],
    description: "Contact us to discuss glass cleaning in a sheet format, including formulation, directions for use, and suitability for your intended surfaces.",
  },
  {
    name: "Hand Soap Sheets (Single-Use)",
    slug: "hand-soap-sheet-single-use",
    sku: "KL-HSS-SU",
    category: "sheets",
    images: [
      {
        src: handSoapSheetSingleUseImage,
        alt: productImageAlt["klean-leaf-hand-soap-sheet-single-use.webp"],
      },
      {
        src: handSoapSheetSingleUseWashingImage,
        alt: productImageAlt["klean-leaf-hand-soap-sheet-single-use-handwashing.webp"],
      },
      {
        src: productInUseImage15,
        alt: productImageAlt["klean-leaf-hand-soap-sheet-single-use-product-in-use.webp"],
      },
    ],
    description: "Contact us to discuss a single-use hand soap sheet project, including formulation, directions for use, and packaging specifications.",
  },
  {
    name: "Hand Soap Sheets (Concentrated)",
    slug: "hand-soap-sheet-concentrated",
    sku: "KL-HSS-CT",
    category: "sheets",
    images: [
      {
        src: handSoapSheetConcentratedImage,
        alt: productImageAlt["klean-leaf-hand-soap-sheet-concentrated.webp"],
      },
      {
        src: handSoapSheetConcentratedRefillImage,
        alt: productImageAlt["klean-leaf-hand-soap-sheet-concentrated-bottle-refill.webp"],
      },
      {
        src: productInUseImage16,
        alt: productImageAlt["klean-leaf-hand-soap-sheet-concentrated-product-in-use.webp"],
      },
    ],
    description: "Contact us to discuss a concentrated hand soap sheet project, including formulation, preparation requirements, and packaging specifications.",
  },
  {
    name: "Laundry Detergent Powder",
    slug: "laundry-detergent-powder",
    sku: "KL-LDPW-RG",
    category: "powders",
    images: [
      {
        src: laundryDetergentPowderImage,
        alt: productImageAlt["klean-leaf-laundry-detergent-powder.webp"],
      },
      {
        src: laundryDetergentPowderScoopImage,
        alt: productImageAlt["klean-leaf-laundry-detergent-powder-scoop-and-towels.webp"],
      },
      {
        src: productInUseImage17,
        alt: productImageAlt["klean-leaf-laundry-detergent-powder-product-in-use.webp"],
      },
      {
        src: laundryDetergentPowderWashingImage,
        alt: productImageAlt["klean-leaf-laundry-detergent-powder-washing-machine.webp"],
      },
    ],
    description: "Powder detergent for laundry washing. Contact us to discuss formulation and product specifications.",
    catalogSku: "KL_FS_13",
    catalogPage: 3,
  },
  {
    name: "Multi-Purpose Cleaning Powder",
    slug: "multi-purpose-cleaning-powder",
    sku: "KL-MPCPW-RG",
    category: "powders",
    images: [
      {
        src: multiPurposeCleaningPowderImage,
        alt: productImageAlt["klean-leaf-multi-purpose-cleaning-powder.webp"],
      },
      {
        src: multiPurposeCleaningPowderSprayImage,
        alt: productImageAlt["klean-leaf-multi-purpose-cleaning-powder-spray-bottle.webp"],
      },
      {
        src: productInUseImage18,
        alt: productImageAlt["klean-leaf-multi-purpose-cleaning-powder-product-in-use.webp"],
      },
    ],
    description: "Powder cleaner for household surfaces. Contact us to discuss intended applications and specifications.",
    catalogSku: "KL_FS_14",
    catalogPage: 3,
    catalogName: "Multi-purpose Cleaning Powder",
  },
  {
    name: "Dishwasher Detergent Powder",
    slug: "dishwasher-detergent-powder",
    sku: "KL-DDPW-RG",
    category: "powders",
    images: [
      {
        src: dishwasherDetergentPowderImage,
        alt: productImageAlt["klean-leaf-dishwasher-detergent-powder.webp"],
      },
      {
        src: galleryKLDDPWRGImage,
        alt: productImageAlt["klean-leaf-dishwasher-detergent-powder-lifestyle.webp"],
      },
      {
        src: productInUseImage19,
        alt: productImageAlt["klean-leaf-dishwasher-detergent-powder-product-in-use.webp"],
      },
    ],
    description: "Powder detergent for dishwashers. Contact us to discuss formulation and specifications for your product range.",
    catalogSku: "KL_FS_15",
    catalogPage: 3,
  },
  {
    name: "Toilet Bowl Cleaner Powder",
    slug: "toilet-bowl-cleaner-powder",
    sku: "KL-TBCPW-RG",
    category: "powders",
    images: [
      {
        src: toiletBowlCleanerPowderImage,
        alt: productImageAlt["klean-leaf-toilet-bowl-cleaner-powder.webp"],
      },
      {
        src: galleryKLTBCPWRGImage,
        alt: productImageAlt["klean-leaf-toilet-bowl-cleaner-powder-lifestyle.webp"],
      },
      {
        src: productInUseImage20,
        alt: productImageAlt["klean-leaf-toilet-bowl-cleaner-powder-product-in-use.webp"],
      },
    ],
    description: "Powder cleaner for toilet bowls. Contact us to discuss product specifications and use requirements.",
    catalogSku: "KL_FS_16",
    catalogPage: 3,
  },
  {
    name: "Dishwasher Detergent Tablets",
    slug: "dishwasher-tablets",
    sku: "KL-DDT-RG",
    category: "tablets",
    images: [
      {
        src: dishwasherTabletsImage,
        alt: productImageAlt["klean-leaf-dishwasher-tablets.webp"],
      },
      {
        src: galleryKLDDTRGImage,
        alt: productImageAlt["klean-leaf-dishwasher-tablets-lifestyle.webp"],
      },
      {
        src: productInUseImage21,
        alt: productImageAlt["klean-leaf-dishwasher-tablets-product-in-use.webp"],
      },
    ],
    description: "Detergent tablets for automatic dishwashers. Contact us to discuss formulation and specifications.",
    catalogSku: "KL_FS_17",
    catalogPage: 3,
  },
  {
    name: "Dishwasher Cleaning Tablets",
    slug: "dishwasher-machine-cleaning-tablets",
    sku: "KL-DMCT-RG",
    category: "tablets",
    images: [
      {
        src: dishwasherMachineCleaningTabletsImage,
        alt: productImageAlt["klean-leaf-dishwasher-machine-cleaning-tablets.webp"],
      },
      {
        src: galleryKLDMCTRGImage,
        alt: productImageAlt["klean-leaf-dishwasher-cleaning-tablets-lifestyle.webp"],
      },
      {
        src: productInUseImage22,
        alt: productImageAlt["klean-leaf-dishwasher-machine-cleaning-tablets-product-in-use.webp"],
      },
    ],
    description: "Contact us to discuss specifications and availability for a dishwasher machine cleaning tablet project.",
    // Dishwasher detergent tablets are a different intended application.
  },
  {
    name: "Multi-Purpose Cleaning Tablets",
    slug: "multi-purpose-cleaning-tablets",
    sku: "KL-MPCT-RG",
    category: "tablets",
    images: [
      {
        src: multiPurposeCleaningTabletsImage,
        alt: productImageAlt["klean-leaf-multi-purpose-cleaning-tablets.webp"],
      },
      {
        src: galleryKLMPCTRGImage,
        alt: productImageAlt["klean-leaf-multi-purpose-tablets-use.webp"],
      },
      {
        src: productInUseImage23,
        alt: productImageAlt["klean-leaf-multi-purpose-cleaning-tablets-product-in-use.webp"],
      },
    ],
    description: "Tablets for general cleaning use. Contact us to discuss intended applications and specifications.",
    catalogSku: "KL_FS_18",
    catalogPage: 3,
  },
  {
    name: "Laundry Detergent Tablets",
    slug: "laundry-detergent-tablets",
    sku: "KL-LDT-RG",
    category: "tablets",
    images: [
      {
        src: laundryDetergentTabletsImage,
        alt: productImageAlt["klean-leaf-laundry-detergent-tablets.webp"],
      },
      {
        src: galleryKLLDTRGImage,
        alt: productImageAlt["klean-leaf-laundry-detergent-tablets-lifestyle.webp"],
      },
      {
        src: productInUseImage24,
        alt: productImageAlt["klean-leaf-laundry-detergent-tablets-product-in-use.webp"],
      },
    ],
    description: "Detergent tablets for laundry washing. Contact us to discuss formulation and product specifications.",
    catalogSku: "KL_FS_19",
    catalogPage: 3,
  },
  {
    name: "Hand Soap Tablets",
    slug: "hand-soap-tablets",
    sku: "KL-HST-RG",
    category: "tablets",
    images: [
      {
        src: handSoapTabletsImage,
        alt: productImageAlt["klean-leaf-hand-soap-tablets.webp"],
      },
      {
        src: galleryKLHSTRGImage,
        alt: productImageAlt["klean-leaf-hand-soap-tablets-lifestyle.webp"],
      },
      {
        src: productInUseImage25,
        alt: productImageAlt["klean-leaf-hand-soap-tablets-product-in-use.webp"],
      },
    ],
    description: "Dissolvable tablets for hand soap refill. Contact us to discuss formulation and specifications.",
    catalogSku: "KL_FS_20",
    catalogPage: 3,
    catalogName: "Hand Soap Tablet",
    detailSections: [
      {
        id: "packaging", type: "packaging", enabled: true,
        options: [{
          id: "paper-box", packagingType: "paperBox", name: "Paper Box",
          description: "Retail box presentation for hand soap tablets.",
          note: "Confirm the inner packaging, pack count and artwork for your project.",
          image: { src: handSoapTabletsImage, alt: "Klean Leaf hand soap tablets box with a wrapped tablet" },
        }],
      },
      // The photo shows a wrapped tablet, but the candy-style supply specification
      // is not confirmed. Keep disabled until approved; tests exercise this shape.
      {
        id: "individual-wrapper", type: "packaging", enabled: false,
        options: [{
          id: "candy-wrapper", packagingType: "candyWrapper", name: "Individual Candy-Style Wrapper",
          description: "Individual tablet wrapping with an outer retail box.",
          note: "Individually wrapped tablets packed in a retail box. Confirm the packaging specification for your project.",
          image: { src: handSoapTabletsImage, alt: "Wrapped Klean Leaf hand soap tablet beside its retail box" },
        }],
      },
      { id: "usage", type: "howToUse", enabled: false, steps: [] },
      {
        id: "moq", type: "moq", enabled: true,
        message: "Contact us to confirm the MOQ for your configuration.",
        note: "Tablet specifications, inner wrapping and retail packaging are reviewed for each project.",
        cta: { label: "Confirm Your MOQ" },
      },
      {
        id: "refill-format", type: "imageText", enabled: true, imageSide: "left",
        eyebrow: "Refill format", title: "Hand soap tablets for a refill routine",
        description: "Discuss a dissolvable tablet format for hand soap refill, including the tablet specification, packaging and intended bottle setup.",
        image: { src: handSoapTabletKitRefillImage, alt: "Klean Leaf hand soap tablet with a refill bottle" },
      },
    ],
  },
  {
    name: "Baby Bottle Cleaning Tablets",
    slug: "baby-nursing-bottle-cleaning-tablets",
    sku: "KL-BBCT-RG",
    category: "tablets",
    images: [
      {
        src: babyBottleCleaningTabletsImage,
        alt: productImageAlt["klean-leaf-baby-bottle-cleaning-tablets.webp"],
      },
      {
        src: galleryKLBBCTRGImage,
        alt: productImageAlt["klean-leaf-baby-nursing-bottle-cleaning-tablets-lifestyle.webp"],
      },
      {
        src: productInUseImage26,
        alt: productImageAlt["klean-leaf-baby-nursing-bottle-cleaning-tablets-product-in-use.webp"],
      },
    ],
    description: "Tablets intended for cleaning baby bottles and feeding accessories. Contact us to discuss specifications and suitability for your intended use.",
    catalogSku: "KL_FS_24",
    catalogPage: 3,
    catalogName: "Baby Bottle Cleaning Tablets",
  },
  {
    name: "Laundry Machine Tablets for Pet Owners",
    slug: "laundry-machine-tablets-for-pet-owners",
    sku: "KL-LMT-PT",
    category: "tablets",
    images: [
      {
        src: petOwnerLaundryMachineTabletsImage,
        alt: productImageAlt["klean-leaf-laundry-machine-tablets-for-pet-owners.webp"],
      },
      {
        src: galleryKLLMTPTImage,
        alt: productImageAlt["klean-leaf-laundry-machine-tablets-for-pet-owners-lifestyle.webp"],
      },
      {
        src: productInUseImage27,
        alt: productImageAlt["klean-leaf-laundry-machine-tablets-for-pet-owners-product-in-use.webp"],
      },
    ],
    description: "Discuss requirements, specifications, and availability for a laundry machine tablet project for pet owners.",
    // KL_FS_22 does not identify a pet-owner variant or establish pet claims.
  },
  {
    name: "Toilet Bowl Cleaner Tablets",
    slug: "toilet-bowl-cleaner-tablets",
    sku: "KL-TBCT-RG",
    category: "tablets",
    images: [
      {
        src: toiletBowlCleanerTabletsImage,
        alt: productImageAlt["klean-leaf-toilet-bowl-cleaner-tablets.webp"],
      },
      {
        src: galleryKLTBCTRGImage,
        alt: productImageAlt["klean-leaf-toilet-bowl-cleaner-tablets-lifestyle.webp"],
      },
      {
        src: productInUseImage28,
        alt: productImageAlt["klean-leaf-toilet-bowl-cleaner-tablets-product-in-use.webp"],
      },
    ],
    description: "Tablets for toilet bowl cleaning. Contact us to discuss product specifications and use requirements.",
    catalogSku: "KL_FS_21",
    catalogPage: 3,
  },
  {
    name: "Coffee Machine Cleaning Tablets",
    slug: "coffee-machine-cleaning-tablets",
    sku: "KL-CMCT-RG",
    category: "tablets",
    images: [
      {
        src: coffeeMachineCleaningTabletsImage,
        alt: productImageAlt["klean-leaf-coffee-machine-cleaning-tablets.webp"],
      },
      {
        src: galleryKLCMCTRGImage,
        alt: productImageAlt["klean-leaf-coffee-machine-cleaning-tablets-lifestyle.webp"],
      },
      {
        src: productInUseImage29,
        alt: productImageAlt["klean-leaf-coffee-machine-cleaning-tablets-product-in-use.webp"],
      },
    ],
    description: "Tablets for cleaning coffee machines. Contact us to discuss specifications and compatibility with your intended equipment.",
    catalogSku: "KL_FS_23",
    catalogPage: 3,
  },
  {
    name: "Glass Cleaning Tablets",
    slug: "glass-cleaning-tablets",
    sku: "KL-GCT-RG",
    category: "tablets",
    images: [
      {
        src: glassCleaningTabletsImage,
        alt: productImageAlt["klean-leaf-glass-cleaning-tablets.webp"],
      },
      {
        src: galleryKLGCTRGImage,
        alt: productImageAlt["klean-leaf-glass-cleaning-tablets-lifestyle.webp"],
      },
      {
        src: productInUseImage30,
        alt: productImageAlt["klean-leaf-glass-cleaning-tablets-product-in-use.webp"],
      },
    ],
    description: "Contact us to discuss glass cleaning tablets, including formulation, preparation requirements, and suitability for your intended surfaces.",
  },
  {
    name: "Laundry Detergent Pods",
    slug: "laundry-pods",
    sku: "KL-LDP-RG",
    category: "pods",
    images: [
      {
        src: laundryDetergentPodsImage,
        alt: productImageAlt["klean-leaf-laundry-detergent-pods.webp"],
      },
      {
        src: galleryKLLDPRGImage,
        alt: productImageAlt["klean-leaf-laundry-pods-lifestyle.webp"],
      },
      {
        src: productInUseImage31,
        alt: productImageAlt["klean-leaf-laundry-pods-product-in-use.webp"],
      },
    ],
    description: "A pod format for laundry detergent. Contact us to discuss the formulation and specifications for your project.",
    // Regular Pods and multiple KLP variants do not provide one generic catalog SKU.
  },
  {
    name: "Dishwasher Detergent Pods",
    slug: "dishwasher-pods",
    sku: "KL-DDP-RG",
    category: "pods",
    images: [
      {
        src: dishwasherDetergentPodsImage,
        alt: productImageAlt["klean-leaf-dishwasher-detergent-pods.webp"],
      },
      {
        src: galleryKLDDPRGImage,
        alt: productImageAlt["klean-leaf-dishwasher-pods-lifestyle.webp"],
      },
      {
        src: productInUseImage32,
        alt: productImageAlt["klean-leaf-dishwasher-pods-product-in-use.webp"],
      },
    ],
    description: "Pre-measured detergent pods for dishwashers. Contact us to discuss formulation and product specifications.",
    catalogSku: "KL_FS_26",
    catalogPage: 4,
  },
  {
    name: "Dishwasher Detergent Pods (Powder + Liquid)",
    slug: "dishwasher-pods-powder-liquid",
    sku: "KL-DDP-PL",
    category: "pods",
    images: [
      {
        src: dishwasherPowderLiquidPodsImage,
        alt: productImageAlt["klean-leaf-dishwasher-detergent-pods-powder-liquid.webp"],
      },
      {
        src: galleryKLDDPPLImage,
        alt: productImageAlt["klean-leaf-dishwasher-pods-powder-liquid-lifestyle.webp"],
      },
      {
        src: productInUseImage33,
        alt: productImageAlt["klean-leaf-dishwasher-pods-powder-liquid-product-in-use.webp"],
      },
    ],
    description: "Dishwasher pods in a combined powder and liquid format. Contact us to discuss specifications for your product range.",
    catalogSku: "KLP-21",
    catalogPage: 5,
    catalogName: "Dishwasher Pods: Powder Liquid",
  },
  {
    name: "Laundry Booster Pods",
    slug: "booster-laundry-pods",
    sku: "KL-LBP-RG",
    category: "pods",
    images: [
      {
        src: laundryBoosterPodsImage,
        alt: productImageAlt["klean-leaf-laundry-booster-pods.webp"],
      },
      {
        src: galleryKLLBPRGImage,
        alt: productImageAlt["klean-leaf-booster-laundry-pods-lifestyle.webp"],
      },
      {
        src: productInUseImage34,
        alt: productImageAlt["klean-leaf-booster-laundry-pods-product-in-use.webp"],
      },
    ],
    description: "Booster pods for laundry care. Contact us to discuss the formulation, intended use, and product specifications.",
    catalogSku: "KL_FS_29",
    catalogPage: 4,
  },
  {
    name: "Fragrance Booster Beads",
    slug: "fragrance-booster-beads",
    sku: "KL-FBB-RG",
    category: "fragrance-booster-beads",
    images: [
      {
        src: fragranceBeadsOceanBreezeImage,
        alt: productImageAlt["klean-leaf-fragrance-booster-beads-ocean-breeze.webp"],
      },
      {
        src: galleryKLFBBRGImage,
        alt: productImageAlt["klean-leaf-fragrance-booster-beads-lifestyle.webp"],
      },
      {
        src: productInUseImage35,
        alt: productImageAlt["klean-leaf-fragrance-booster-beads-product-in-use.webp"],
      },
    ],
    description: "Fragrance beads for laundry washing. Contact us to discuss product specifications for your laundry care range.",
    catalogSku: "KL_FS_31",
    catalogPage: 4,
    catalogName: "Scent Booster Beads",
  },
  {
    name: "Fragrance Booster Beads (Concentrated)",
    slug: "fragrance-booster-beads-concentrated",
    sku: "KL-FBB-CT",
    category: "fragrance-booster-beads",
    images: [
      {
        src: concentratedFragranceBeadsLavenderImage,
        alt: productImageAlt["klean-leaf-fragrance-booster-beads-concentrated-lavender.webp"],
      },
      {
        src: galleryKLFBBCTImage,
        alt: productImageAlt["klean-leaf-fragrance-booster-beads-concentrated-lifestyle.webp"],
      },
      {
        src: productInUseImage36,
        alt: productImageAlt["klean-leaf-fragrance-booster-beads-concentrated-product-in-use.webp"],
      },
    ],
    description: "Concentrated fragrance beads for laundry washing. Contact us to discuss formulation and product specifications.",
    catalogSku: "KL_FS_32",
    catalogPage: 4,
    catalogName: "Scent Booster Beads (concentrated)",
  },
  {
    name: "Stain Removal Spray",
    slug: "stain-removal-spray",
    sku: "KL-SRS-RG",
    category: "stain-removal",
    images: [
      {
        src: stainRemovalSprayImage,
        alt: productImageAlt["klean-leaf-stain-removal-spray.webp"],
      },
      {
        src: stainRemovalSprayUseImage,
        alt: productImageAlt["klean-leaf-stain-removal-spray-use-guide.webp"],
      },
      {
        src: productInUseImage37,
        alt: productImageAlt["klean-leaf-stain-removal-spray-product-in-use.webp"],
      },
      {
        src: stainRemovalEnzymeGuideImage,
        alt: productImageAlt["klean-leaf-enzyme-stain-guide.webp"],
      },
    ],
    description: "Spray cleaner for fabric stain treatment. Contact us to discuss specifications and suitability for your intended fabrics.",
    catalogSku: "KL_FS_33",
    catalogPage: 4,
    catalogName: "Stain Remover Spray",
  },
  {
    name: "Stain Removal Wipes",
    slug: "stain-removal-wipes",
    sku: "KL-SRW-RG",
    category: "stain-removal",
    images: [
      {
        src: stainRemovalWipesImage,
        alt: productImageAlt["klean-leaf-stain-removal-wipes.webp"],
      },
      {
        src: galleryKLSRWRGImage,
        alt: productImageAlt["klean-leaf-stain-removal-wipes-use.webp"],
      },
      {
        src: productInUseImage38,
        alt: productImageAlt["klean-leaf-stain-removal-wipes-product-in-use.webp"],
      },
      {
        src: stainRemovalEnzymeGuideImage,
        alt: productImageAlt["klean-leaf-enzyme-stain-guide.webp"],
      },
    ],
    description: "Wipes for spot stain treatment. Contact us to discuss product specifications and intended applications.",
    catalogSku: "KL_FS_34",
    catalogPage: 4,
    catalogName: "Stain Remover Wipes",
  },
  {
    name: "Stain Removal Pen",
    slug: "stain-removal-pen",
    sku: "KL-SRP-RG",
    category: "stain-removal",
    images: [
      {
        src: stainRemovalPenImage,
        alt: productImageAlt["klean-leaf-stain-removal-pen.webp"],
      },
      {
        src: stainRemovalPenUseImage,
        alt: productImageAlt["klean-leaf-stain-removal-pen-travel-use.webp"],
      },
      {
        src: productInUseImage39,
        alt: productImageAlt["klean-leaf-stain-removal-pen-product-in-use.webp"],
      },
      {
        src: stainRemovalPenPortableImage,
        alt: productImageAlt["klean-leaf-stain-removal-pen-portable-comparison.webp"],
      },
      {
        src: stainRemovalPenGreenImage,
        alt: productImageAlt["klean-leaf-stain-removal-pen-green-detail.webp"],
      },
      {
        src: stainRemovalEnzymeGuideImage,
        alt: productImageAlt["klean-leaf-enzyme-stain-guide.webp"],
      },
    ],
    description: "Develop a portable stain remover pen for your brand, with targeted enzyme or multi-purpose formula options, a choice of applicators, and custom branding.",
    // Development options and order quantities supplied in the user's stain remover pen brief.
    // Catalog SKU and final technical specifications remain project-specific.
    detailSections: [
      {
        id: "highlights", type: "productHighlights", enabled: true,
        title: "Product Highlights",
        image: {
          src: stainRemovalPenGreenImage,
          alt: "Klean Leaf stain remover pens in four colors with an uncapped green rollerball pen",
          fit: "contain",
        },
        items: [
          {
            id: "portable-spot-treatment",
            text: "Pocket-size spot treatment: a compact pen for handbags, desk drawers, travel kits, and everyday spills away from home.",
          },
          {
            id: "targeted-enzyme-formula",
            text: "A formula built around your priority stains: select enzymes for protein residues, cooking oils, or other target soils, with supporting raw materials chosen around your performance and environmental goals.",
          },
          {
            id: "multi-purpose-option",
            text: "Targeted or multi-purpose: focus development on a specific stain challenge, or choose broader coverage for a range of everyday spills.",
          },
          {
            id: "applicator-choice",
            text: "A choice of three applicators: choose the rollerball format shown here, or discuss a felt or brush tip to suit the formula and intended use.",
          },
          {
            id: "brand-and-shape",
            text: "Make it your own: add your logo to an existing pen, or develop a distinctive custom shape or refillable design with separately quoted tooling.",
          },
        ],
      },
      {
        id: "enzyme-guide", type: "comparisonTable", enabled: true,
        title: "Match the Enzyme to the Stain",
        description: "Different enzymes target different stain components. Use this guide to identify your priorities before developing a custom formula with Klean Leaf.",
        caption: "Which enzymes target which stain components?",
        columns: ["Enzyme", "Main target", "Typical stain examples"],
        rows: [
          {
            id: "protease",
            values: ["Protease", "Proteins", "Protein residues in milk, eggs, meat, and blood"],
          },
          {
            id: "lipase",
            values: ["Lipase", "Fats and oils", "Cooking oil, butter, and susceptible oily components in body soils or cosmetics"],
          },
          {
            id: "amylase",
            values: ["Amylase", "Starch", "Starch residues from rice, noodles, potatoes, baby foods, and thickened sauces"],
          },
          {
            id: "mannanase",
            values: ["Mannanase", "Mannan-based thickeners, such as guar gum", "Guar-gum-containing ice cream, salad dressings, and sauces"],
          },
          {
            id: "pectate-lyase",
            values: ["Pectate lyase", "Pectin-related residues", "Pectin-containing fruit, jam, smoothies, and fruit or vegetable drinks"],
          },
        ],
        note: "These are formulation options, not a list of enzymes included in every pen. For protein-based food residues and cooking oil, R&D can evaluate protease with lipase. Every proposed blend is reviewed for cleaning performance, fabric suitability, and storage stability; adding more enzyme types is not automatically better.",
        link: {
          href: "/blogs/custom-stain-remover-pens",
          label: "Read the Stain Remover Pen Guide",
        },
      },
      { id: "usage", type: "howToUse", enabled: true },
      {
        id: "moq", type: "moq", enabled: true,
        rows: [{
          id: "custom-formula",
          configuration: "Custom formula in an existing pen body",
          quantity: "2,500",
          unit: "pens",
          note: "Custom shapes have a separate MOQ and mold fee, quoted after design review.",
        }],
      },
    ],
  },
  {
    name: "Wool Dryer Balls",
    slug: "wool-dryer-balls",
    sku: "KL-WDB-RG",
    category: "laundry-accessories",
    images: [
      {
        src: woolDryerBallsImage,
        alt: productImageAlt["klean-leaf-wool-dryer-balls.webp"],
      },
      {
        src: woolDryerBallsThreePackImage,
        alt: productImageAlt["klean-leaf-wool-dryer-balls-three-pack.webp"],
      },
      {
        src: productInUseImage40,
        alt: productImageAlt["klean-leaf-wool-dryer-balls-product-in-use.webp"],
      },
      {
        src: woolDryerBallsHighlightsImage,
        alt: productImageAlt["klean-leaf-wool-dryer-balls-product-highlights.webp"],
      },
    ],
    description: "Wool balls for use in dryer cycles. Contact us to discuss specifications for your laundry accessory range.",
    catalogSku: "KL_FS_35",
    catalogPage: 4,
  },
  {
    name: "Laundry Detergent Sheets (Vending Machine Pack)",
    slug: "laundry-detergent-sheets-vending-machine-pack",
    sku: "KL-LDS-VM",
    category: "laundry-accessories",
    additionalCategories: ["sheets"],
    images: [
      {
        src: vendingMachinePackImage,
        alt: productImageAlt["klean-leaf-laundry-detergent-sheets-vending-machine-pack.webp"],
      },
      {
        src: vendingMachineDisplayImage,
        alt: productImageAlt["klean-leaf-laundry-detergent-sheets-vending-machine-display.webp"],
      },
      {
        src: productInUseImage41,
        alt: productImageAlt["klean-leaf-laundry-detergent-sheets-vending-machine-pack-product-in-use.webp"],
      },
    ],
    description: "Contact us to discuss a laundry detergent sheet packaging project for vending machines, including pack dimensions, machine compatibility, and availability.",
    // User-requested packaging option; catalog SKU and specifications are unconfirmed.
  },
  {
    name: "Plastic Spray Bottle",
    slug: "plastic-spray-bottle",
    sku: "KL-SBT-PL",
    category: "laundry-accessories",
    images: [
      {
        src: plasticSprayBottlesImage,
        alt: productImageAlt["klean-leaf-plastic-spray-bottles.webp"],
      },
      {
        src: galleryKLSBTPLImage,
        alt: productImageAlt["klean-leaf-plastic-spray-bottle-lifestyle.webp"],
      },
      {
        src: productInUseImage42,
        alt: productImageAlt["klean-leaf-plastic-spray-bottle-product-in-use.webp"],
      },
    ],
    description: "Contact us to discuss a plastic spray bottle for your product range, including capacity, dispenser options, and compatibility with your formulation.",
  },
  {
    name: "Glass Foaming Bottle",
    slug: "glass-foaming-bottle",
    sku: "KL-FBT-GL",
    category: "laundry-accessories",
    images: [
      {
        src: glassFoamingBottlesImage,
        alt: productImageAlt["klean-leaf-glass-foaming-bottles.webp"],
      },
      {
        src: galleryKLFBTGLImage,
        alt: productImageAlt["klean-leaf-glass-foaming-bottle-lifestyle.webp"],
      },
      {
        src: productInUseImage43,
        alt: productImageAlt["klean-leaf-glass-foaming-bottle-product-in-use.webp"],
      },
    ],
    description: "Contact us to discuss a glass foaming bottle for your product range, including capacity, pump options, and compatibility with your formulation.",
  },
  {
    name: "Glass Spray Bottle",
    slug: "glass-spray-bottle",
    sku: "KL-SBT-GL",
    category: "laundry-accessories",
    images: [
      {
        src: glassSprayBottlesImage,
        alt: productImageAlt["klean-leaf-glass-spray-bottles.webp"],
      },
      {
        src: galleryKLSBTGLImage,
        alt: productImageAlt["klean-leaf-glass-spray-bottle-lifestyle.webp"],
      },
      {
        src: productInUseImage44,
        alt: productImageAlt["klean-leaf-glass-spray-bottle-product-in-use.webp"],
      },
    ],
    description: "Contact us to discuss a glass spray bottle for your product range, including capacity, dispenser options, and compatibility with your formulation.",
  },
  // Kit contents and quantities are project-specific and have not been confirmed.
  {
    name: "Multi-Purpose Cleaning Sheet Kit",
    slug: "multi-purpose-sheet-kit",
    sku: "KL-MPCS-KT",
    category: "kit",
    images: [
      {
        src: multiPurposeSheetKitImage,
        alt: productImageAlt["klean-leaf-multi-purpose-cleaning-sheet-kit.webp"],
      },
      {
        src: multiPurposeSheetsRefillImage,
        alt: productImageAlt["klean-leaf-multi-purpose-cleaning-sheets-bottle-refill.webp"],
      },
      {
        src: productInUseImage45,
        alt: productImageAlt["klean-leaf-multi-purpose-sheet-kit-product-in-use.webp"],
      },
    ],
    additionalCategories: ["sheets"],
    description: "Contact us to discuss a multi-purpose cleaning sheet kit, including sheet specifications, kit contents, and retail packaging options.",
  },
  {
    name: "Multi-Purpose Cleaning Tablet Kit",
    slug: "multi-purpose-tablet-kit",
    sku: "KL-MPCT-KT",
    category: "kit",
    images: [
      {
        src: multiPurposeTabletKitImage,
        alt: productImageAlt["klean-leaf-multi-purpose-cleaning-tablet-kit.webp"],
      },
      {
        src: multiPurposeTabletKitRefillImage,
        alt: productImageAlt["klean-leaf-multi-purpose-cleaning-tablet-kit-bottle-refill.webp"],
      },
      {
        src: productInUseImage46,
        alt: productImageAlt["klean-leaf-multi-purpose-tablet-kit-product-in-use.webp"],
      },
      {
        src: multiPurposeTabletKitKitchenImage,
        alt: productImageAlt["klean-leaf-multi-purpose-cleaning-tablet-kit-kitchen-refill.webp"],
      },
    ],
    additionalCategories: ["tablets"],
    description: "Contact us to discuss a multi-purpose cleaning tablet kit, including tablet specifications, kit contents, and retail packaging options.",
  },
  {
    name: "Glass Cleaning Sheet Kit",
    slug: "glass-cleaning-sheet-kit",
    sku: "KL-GCS-KT",
    category: "kit",
    additionalCategories: ["sheets"],
    description: "Contact us to discuss a glass cleaning sheet kit, including sheet specifications, kit contents, and packaging requirements for your project.",
    images: [
      {
        src: glassCleaningSheetKitImage,
        alt: productImageAlt["klean-leaf-glass-cleaning-sheet-kit.webp"],
      },
      {
        src: glassCleaningSheetKitDetailImage,
        alt: productImageAlt["klean-leaf-glass-cleaning-sheet-kit-detail.webp"],
      },
      {
        src: productInUseImage47,
        alt: productImageAlt["klean-leaf-glass-cleaning-sheet-kit-product-in-use.webp"],
      },
    ],
  },
  {
    name: "Glass Cleaning Tablet Kit",
    slug: "glass-cleaning-tablet-kit",
    sku: "KL-GCT-KT",
    category: "kit",
    additionalCategories: ["tablets"],
    description: "Contact us to discuss a glass cleaning tablet kit, including tablet specifications, kit contents, and packaging requirements for your project.",
    images: [
      {
        src: glassCleaningTabletKitImage,
        alt: productImageAlt["klean-leaf-glass-cleaning-tablet-kit.webp"],
      },
      {
        src: glassCleaningTabletKitDetailImage,
        alt: productImageAlt["klean-leaf-glass-cleaning-tablet-kit-detail.webp"],
      },
      {
        src: productInUseImage48,
        alt: productImageAlt["klean-leaf-glass-cleaning-tablet-kit-product-in-use.webp"],
      },
    ],
  },
  {
    name: "Hand Soap Sheet Kit",
    slug: "hand-soap-sheet-kit",
    sku: "KL-HSS-KT",
    category: "kit",
    images: [
      {
        src: handSoapSheetKitImage,
        alt: productImageAlt["klean-leaf-hand-soap-sheet-kit.webp"],
      },
      {
        src: handSoapSheetConcentratedRefillImage,
        alt: productImageAlt["klean-leaf-hand-soap-sheet-concentrated-bottle-refill.webp"],
      },
      {
        src: productInUseImage49,
        alt: productImageAlt["klean-leaf-hand-soap-sheet-kit-product-in-use.webp"],
      },
    ],
    additionalCategories: ["sheets"],
    description: "Contact us to discuss a hand soap sheet kit, including the intended use, sheet specifications, kit contents, and retail packaging.",
  },
  {
    name: "Hand Soap Tablet Kit",
    slug: "hand-soap-tablet-kit",
    sku: "KL-HST-KT",
    category: "kit",
    images: [
      {
        src: handSoapTabletKitImage,
        alt: productImageAlt["klean-leaf-hand-soap-tablet-kit.webp"],
      },
      {
        src: handSoapTabletKitRefillImage,
        alt: productImageAlt["klean-leaf-hand-soap-tablet-kit-bottle-refill.webp"],
      },
      {
        src: productInUseImage50,
        alt: productImageAlt["klean-leaf-hand-soap-tablet-kit-product-in-use.webp"],
      },
    ],
    additionalCategories: ["tablets"],
    description: "Contact us to discuss a hand soap tablet kit, including tablet specifications, kit contents, and retail packaging requirements.",
  },
  {
    name: "Laundry, Dishwashing & Multi-Purpose Cleaning Tablet Kit",
    slug: "laundry-dishwashing-multi-purpose-cleaning-tablet-kit",
    sku: "KL-HCT-KT",
    category: "kit",
    images: [
      {
        src: homeCareTabletKitImage,
        alt: productImageAlt["klean-leaf-laundry-dishwashing-multi-purpose-tablet-kit.webp"],
      },
      {
        src: galleryKLHCTKTImage,
        alt: productImageAlt["klean-leaf-laundry-dishwashing-multi-purpose-cleaning-tablet-kit-lifestyle.webp"],
      },
      {
        src: productInUseImage51,
        alt: productImageAlt["klean-leaf-laundry-dishwashing-multi-purpose-cleaning-tablet-kit-product-in-use.webp"],
      },
    ],
    additionalCategories: ["tablets"],
    description: "Contact us to discuss a kit combining laundry detergent tablets, dishwasher detergent tablets, and multi-purpose cleaning tablets. Tablet specifications, kit contents, quantities, and packaging can be discussed for your project.",
  },
];

export const products = productDefinitions.map((product) => ({
  ...product,
  images: product.images || [
    { ...productPlaceholder },
    {
      ...secondaryProductPlaceholder,
      alt: `${product.name} — additional product image coming soon`,
    },
  ],
}));

export const isProductInCategory = (product, categoryId) => (
  product.category === categoryId || (product.additionalCategories || []).includes(categoryId)
);

export const productCategories = [
  { id: "sheets", name: "Sheets" },
  { id: "powders", name: "Powders" },
  { id: "tablets", name: "Tablets" },
  { id: "pods", name: "Pods" },
  { id: "fragrance-booster-beads", name: "Fragrance Booster Beads" },
  { id: "stain-removal", name: "Stain Removal" },
  // Keep existing category filter URLs valid as the accessory range expands.
  { id: "laundry-accessories", name: "Accessories" },
  { id: "kit", name: "Kit" },
].map((category) => ({
  ...category,
  count: products.filter((product) => isProductInCategory(product, category.id)).length,
}));

export const getProductBySlug = (slug) => products.find((product) => product.slug === slug);

export const getProductCategory = (categoryId) => productCategories.find((category) => category.id === categoryId);

export const getProductCategories = (product) => (
  [...new Set([product.category, ...(product.additionalCategories || [])])]
    .map(getProductCategory)
    .filter(Boolean)
);
